import { isLanguage, Language } from './Localized.ts';
import { LocalStorageBase } from './LocalStorageBase.ts';

export function createLocalStorageLanguageAccessor(
    key: string,
    discardEn: boolean = false,
): [() => Language | null, (language: Language) => void] {
    const get = (): Language | null => {
        const storageString = LocalStorageBase.getStringItem(key);
        return isLanguage(storageString, discardEn) ? storageString : null;
    };

    const set = (language: Language): void => {
        LocalStorageBase.setStringItem(key, language);
    };

    return [get, set];
}
